export const DndItemTypes = {
    BOX: 'box',
}
